import React from 'react'
import * as UI from 'ui'
import { Translation } from '@morningtrain/react-translations'
import { ExecuteOperationForModelOnPipe, ExecuteOperationOnPipe, useOperation } from '@morningtrain/react-resources'
import ConfirmOnClickPipeline from 'support/pipelines/ConfirmOnClickPipeline'
import OnClickPipeline from 'support/pipelines/OnClickPipeline'
import { CanUseModel } from '@morningtrain/react-auth'
import { WhenIsPiping } from '@morningtrain/react-pipelines'
import { LoadingSpinner } from 'ui/animations'

export default function EmploymentAction ({
  children,
  title = null,
  action = null,
  confirm = true,
  color = 'lightgray',
  namespace = null,
  resourceName = null,
  operationName = null
}) {
  if (!action) {
    return null
  }

  const parentOperation = useOperation()
  const resource = parentOperation.resource

  const _namespace = namespace || resource.namespace || 'api'
  const _resourceName = resourceName || resource.slug
  const _operationName = action || operationName

  const trigger = (
    <UI.Button color={color}>
      <UI.Text className='flex space-x-3 items-center' block>
        <div>{title || <Translation name={'actions.' + action} />}</div>
        <WhenIsPiping>
          <LoadingSpinner />
        </WhenIsPiping>
      </UI.Text>
    </UI.Button>
  )

  const Pipeline = confirm ? ConfirmOnClickPipeline : OnClickPipeline

  return (
    <CanUseModel permission={[_namespace, _resourceName, _operationName].join('.')}>
      <Pipeline trigger={trigger}>
        <ExecuteOperationForModelOnPipe operationName={action} />
        <ExecuteOperationForModelOnPipe operationName='read' />
        <ExecuteOperationOnPipe namespace='api' resourceName='employments.employment' operationName='index' />
        {children}
      </Pipeline>
    </CanUseModel>
  )
}
